import {createSelector} from '@ngrx/store';

import * as fromBranchOfficeReducer from './branch-office.reducer'
import {AppState} from 'src/app/store/reducers';


export const currentState = (state: AppState) => (state[fromBranchOfficeReducer.branchOfficesFeatureKey]);

export const selectAllBranchOffices = createSelector(currentState, fromBranchOfficeReducer.selectAll);

export const selectTotalBranchOffice = createSelector(currentState, fromBranchOfficeReducer.selectTotal);

// export const selectModifiedInstitution = createSelector(selectAllInstitutions, (institutions) => {
//   return institutions.map((institution) => {
//     return {
//       ...institution,
//       modInstitutionMinistry: institution?.institutionMinistry?.ministryName,
//       modInstitutionSector: institution?.institutionSector?.sectorName
//     };
//   });
// });

export const selectModifiedBranchOffice = createSelector(selectAllBranchOffices, (branchOffices) => {
  return branchOffices.map((branchOffice) => {
    return {
      ...branchOffice,
      location: branchOffice?.officeRegions?.reginalName ? `${branchOffice?.officeRegions?.reginalName}, `: ''
      + branchOffice?.officeDistrics?.districName ? `${branchOffice?.officeDistrics?.districName}, `: ''
      + branchOffice?.officeWards?.wardName ? `${branchOffice?.officeWards?.wardName}, `: ''
      + branchOffice?.officeStreets?.streetName ? `${branchOffice?.officeStreets?.streetName}`: ''
    };
  });
});

